var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenedLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9998 18V5.1L0.0498047 0.85L1.8498 0L4.1998 5.05H15.7998L18.1498 0L19.9498 0.85L17.9998 5.1V18H1.9998ZM7.9998 11H11.9998C12.2831 11 12.5208 10.904 12.7128 10.712C12.9048 10.52 13.0005 10.2827 12.9998 10C12.9991 9.71733 12.9031 9.48 12.7118 9.288C12.5205 9.096 12.2831 9 11.9998 9H7.9998C7.71647 9 7.47914 9.096 7.2878 9.288C7.09647 9.48 7.00047 9.71733 6.9998 10C6.99914 10.2827 7.09514 10.5203 7.2878 10.713C7.48047 10.9057 7.7178 11.0013 7.9998 11ZM3.9998 16H15.9998V7.05H3.9998V16Z",
    fill: "#378114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenedLegend);
export default __webpack_public_path__ + "static/media/opened-legend.100a0c09022773f888329b6893b64163.svg";
export { ForwardRef as ReactComponent };